import { useCallback, useState } from 'react';
import { prepareFiles } from '../lib/file-size';

/**
 * Wraps {@link prepareFiles} with a `converting` flag so drag-drop zones and
 * raw `<input>`s can show the same "Converting…" affordance FileInput provides
 * during (possibly slow) HEIC→JPEG conversion.
 */
export function useFilePrepare() {
	const [converting, setConverting] = useState(false);

	const prepare = useCallback(
		async (files: FileList | File[], accept?: string): Promise<File[]> => {
			setConverting(true);
			try {
				return await prepareFiles(files, accept);
			} finally {
				setConverting(false);
			}
		},
		[]
	);

	return { prepare, converting };
}
